import React from 'react';
import { motion } from 'framer-motion';
import { config } from '../../config/jewelleryLandingConfig';

const scrollToContact = (e) => {
  e.preventDefault();
  const contactSection = document.getElementById('contact');
  if (contactSection) {
    contactSection.scrollIntoView({ behavior: 'smooth' });
  }
};

const FinalCTA = () => {
  return (
    <section className="py-32 bg-espressoDeep relative overflow-hidden">
      {/* Background pattern */}
      <div 
        className="absolute inset-0 opacity-20 bg-cover bg-center mix-blend-overlay luxury-glow-frame" 
        style={{ backgroundImage: `url(${config.media.finalCtaBackground.src})` }}
      ></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/10 rounded-full blur-[100px] pointer-events-none"></div>
      
      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center">
        <div className="luxury-section-kicker justify-center mb-8">
          <span>Final Step</span>
        </div>
        
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-5xl md:text-6xl luxury-serif-heading text-paper mb-8 leading-tight luxury-fade-up"
        >
          Ready to give your jewellery brand a more premium visual presence?
        </motion.h2>
        
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-lg font-light text-soft/80 mb-12 leading-relaxed max-w-2xl mx-auto"
        >
          Send us a product link or a hero item and we will show you how BPA Solutions can turn it into ecommerce-ready model imagery and short-form campaign visuals.
        </motion.p>
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex flex-col sm:flex-row gap-6 justify-center"
        >
          <button 
            onClick={scrollToContact}
            className="luxury-gold-button luxury-gold-sweep"
          >
            Request a Visual Sample
          </button>
          <a 
            href={config.brand.bookingLink} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-flex justify-center items-center px-8 py-4 text-sm tracking-widest uppercase font-medium text-soft border border-gold/50 hover:bg-gold/10 rounded-full transition-all duration-500 backdrop-blur-sm"
          >
            Schedule a Call
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;